import React from 'react';

import styles from '../AssetView.module.scss';
import { TpCollapsedRelationSet } from '../../../data/assets/interfaces';
import { useUser } from '../../../app/hooks';

interface TpRelationLinkProps {
  idx: number;
  lineStartX: number;
  centerTagY: number;
  ofs1: number;
  xPos2: number;
  xPos3: number;
  yPos: number;
  lineEndOffs: number;
  relation?: TpCollapsedRelationSet;
  isReverse: boolean;
  onClickDelete: (relation: TpCollapsedRelationSet) => void;
  setCrossIconLocations: React.Dispatch<React.SetStateAction<any>>;
}

const RelationLink = (props: TpRelationLinkProps) => {
  const {
    idx,
    lineStartX,
    centerTagY,
    ofs1,
    xPos2,
    xPos3,
    yPos,
    lineEndOffs,
    relation,
    isReverse,
    onClickDelete,
    setCrossIconLocations,
  } = props;
  const arrowL = 12;
  const arrowH = 4;
  const { user } = useUser();

  const [strokeWidth, setStrokeWidth] = React.useState(2);

  const scaleAndShowDelete = () => {
    if (relation && user.canWrite) {
      setCrossIconLocations(isReverse ? { x: xPos3 - 60, y: yPos - 10 } : { x: xPos3 + 60, y: yPos - 10 });
      setStrokeWidth(4);
    }
  };

  const resetScaleAndHideDelete = () => {
    if (relation) {
      setCrossIconLocations({ x: 0, y: 0 });
      setStrokeWidth(2);
    }
  };

  const triggerDelete = () => {
    if (relation && user.canWrite) {
      onClickDelete(relation);
    }
  };

  if (isReverse) {
    return (
      <React.Fragment key={`lineD_${idx}`}>
        <g onMouseEnter={scaleAndShowDelete} onMouseLeave={resetScaleAndHideDelete} onClick={triggerDelete}>
          <path
            className={styles.relationsViewPath}
            style={{ strokeWidth: strokeWidth }}
            d={`M ${lineStartX - 20},${centerTagY} C ${lineStartX + ofs1},${0.7 * centerTagY + 0.3 * yPos} ${
              xPos2 - ofs1
            },${yPos} ${xPos2},${yPos} L ${xPos3 - lineEndOffs},${yPos}`}
          />
          <polygon
            className={styles.relationsViewPolygon}
            style={{ strokeWidth: (strokeWidth / 3) * 2 }}
            points={`${xPos3 - lineEndOffs},${yPos} ${xPos3 - lineEndOffs - arrowL},${yPos - arrowH} ${
              xPos3 - lineEndOffs - arrowL
            },${yPos + arrowH}`}
          />
        </g>
      </React.Fragment>
    );
  }
  return (
    <React.Fragment key={`lineU_${idx}`}>
      <g onMouseEnter={scaleAndShowDelete} onMouseLeave={resetScaleAndHideDelete} onClick={triggerDelete}>
        <path
          className={styles.relationsViewPath}
          style={{ strokeWidth: strokeWidth }}
          d={`M ${lineStartX + 20},${centerTagY} C ${lineStartX - ofs1},${0.7 * centerTagY + 0.3 * yPos} ${
            xPos2 + ofs1
          },${yPos} ${xPos2},${yPos} L ${xPos3 + lineEndOffs},${yPos}`}
        ></path>

        <polygon
          className={styles.relationsViewPolygon}
          style={{ strokeWidth: (strokeWidth / 3) * 2 }}
          points={`${xPos3 + lineEndOffs},${yPos} ${xPos3 + lineEndOffs + arrowL},${yPos - arrowH} ${
            xPos3 + lineEndOffs + arrowL
          },${yPos + arrowH}`}
        />
      </g>
    </React.Fragment>
  );
};

export default RelationLink;
